import React from 'react';
import { Form, Input, DatePicker, notification, Spin, Select } from 'antd';
import { Button, Icon, Message } from 'semantic-ui-react';
import { observer } from 'mobx-react';

import './ConversationModalForm.scss';
import Modal from '../../shared/Modal';
import { formatDate } from '../../../utils/functions';
import moment from 'moment';
import AddEditStore from './store';
import CKEditor from './CKEditor';
import {
  getCampaignInfo,
  saveCaseManagerCampaign,
  uploadFileTemplate,
} from './service';

const State = [
  { id: '108', label: 'ACT' },
  { id: '109', label: 'NSW' },
  { id: '110', label: 'VIC' },
  { id: '111', label: 'QLD' },
  { id: '112', label: 'SA' },
  { id: '113', label: 'WA' },
  { id: '114', label: 'TAS' },
  { id: '115', label: 'NT' },
];

const FILE_EXTENSION = [
  'jpg',
  'pdf',
  'jpeg',
  'gif',
  'png',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'htm',
  'html',
  'zip',
  'rar',
  'txt',
  'ds2',
  'rtf',
  'tif',
  'tiff',
  'dss',
  'wav',
  'mp3',
  'mp4',
  'xml',
  'bmp',
  'm4a',
];

@observer
class ConversationModalForm extends React.Component {
  state = {
    loading: true,
    dataCampaign: null,
    loadingUpload: false,
  };
  convertDate = dateStr => {
    if (dateStr) {
      if (typeof dateStr === 'string') {
        return moment(formatDate(dateStr), 'DD MMM YYYY').format('MM-DD-YYYY');
      }
      return dateStr.format('MM-DD-YYYY');
    }
    return null;
  };
  handleSave = () => {
    const { dataCampaign } = this.state;
    const parram = {
      ...dataCampaign,
      CampaignDate: this.convertDate(dataCampaign.CampaignDate),
      CMResponsesDate: this.convertDate(dataCampaign.CMResponsesDate),
      Location:
        dataCampaign.Location.length === 0
          ? null
          : dataCampaign.Location.join(';'),
    };

    if (
      parram.CampaignName &&
      !this.checkRequired('Subject') &&
      !this.checkRequired('From') &&
      !this.checkRequired('To')
    ) {
      Promise.all([saveCaseManagerCampaign(parram)])
        .then(([response]) => {
          if (response.status === 'success') {
            notification.destroy();
            notification.success({
              message: 'Success',
              description: 'Data has been saved successfully.',
              duration: 3,
            });
            AddEditStore.refetch({});
            this.props.onCancel();
          } else if (response.status === 'fail') {
            notification.destroy();
            notification.error({
              message: 'Error',
              description: 'An error occurred, please try again',
              duration: 3,
            });
          }
        })
        .catch(() => {});
    } else {
      notification.destroy();
      notification.error({
        message: 'Error',
        description: 'Invalid form',
        duration: 3,
      });
    }
  };
  componentDidMount() {
    const { id } = AddEditStore.modalParams;
    if (id) {
      Promise.all([getCampaignInfo(id)]).then(([campaignInfo]) => {
        this.setState({
          loading: false,
          dataCampaign: {
            ...campaignInfo.objItem,
            CampaignDate: campaignInfo.objItem.CampaignDate
              ? moment(
                  formatDate(campaignInfo.objItem.CampaignDate),
                  'DD MMM YYYY',
                )
              : null,
            CMResponsesDate: campaignInfo.objItem.CMResponsesDate
              ? moment(
                  formatDate(campaignInfo.objItem.CMResponsesDate),
                  'DD MMM YYYY',
                )
              : null,
            Location: campaignInfo.objItem.Location
              ? campaignInfo.objItem.Location.split(';')
              : [],
          },
        });
      });
    } else {
      this.setState({
        loading: false,
        dataCampaign: {
          Id: 0,
          CampaignName: '',
          Channel: null,
          CampaignDate: moment(),
          CMResponses: false,
          CMResponsesDate: moment(),
          CMResponsesBy: '',
          Comment: '',
          TargetAudience: null,
          TargetStatus: null,
          Location: [],
          ResponsesRate: 0,
          SuccessRate: 0,
          CampaignContent: null,
          Bcc: null,
          From: null,
          To: null,
          Volume: null,
          Subject: null,
          ReplyTo: null,
          Attachments: null,
        },
      });
    }
  }

  handleFieldChecked = fieldName => event => {
    const value = event ? (event.target ? event.target.checked : event) : false;
    if (fieldName === 'CMResponses') {
      if (value) {
        this.setState({ CMResponsesDate: moment() });
      } else {
        this.setState({ CMResponsesDate: null });
      }
    }
    this.setState(state => (state.dataCampaign[fieldName] = value));
  };

  handleFieldChange = fieldName => event => {
    const { dataCampaign } = this.state;
    const value = event ? (event.target ? event.target.value : event) : null;
    if (fieldName === 'ResponsesRate' || fieldName === 'SuccessRate') {
      this.setState({
        dataCampaign: {
          ...dataCampaign,
          [fieldName]: value.replace(/\D/g, '').replace(/[^\d]/g, ''),
        },
      });
    } else {
      this.setState({
        dataCampaign: {
          ...dataCampaign,
          [fieldName]: value,
        },
      });
    }
  };

  checkRequired = fieldName => {
    const { dataCampaign } = this.state;
    if (dataCampaign.Channel === 1665) {
      if (dataCampaign[fieldName]) {
        return false;
      }
      return true;
    }
    return false;
  };

  handleViewFile = fileName => {
    window.open(`/UserFile/CampaignAttachment/${fileName}`, '_blank');
  };

  handleUploadFile = (file, type) => {
    this.loadingUpload = true;
    const formData = new FormData();
    formData.append(file.name, file);

    uploadFileTemplate(formData).then(({ fileList }) => {
      const attachment = {
        FileName: fileList[0].name,
        Title: fileList[0].title,
        NumberOfPages: fileList[0].numberOfPages,
        CampaignId: this.state.dataCampaign.Id,
        AttachmentType: type,
      };
      if (
        this.state.dataCampaign.Attachments &&
        this.state.dataCampaign.Attachments.length
      ) {
        const { dataCampaign } = this.state;
        // const itemId = dataCampaign.Attachments.map(i => i.Id).reduce(function(
        //   idA,
        //   idB,
        // ) {
        //   return idA > idB ? idA : idB;
        // });
        const newAttachments = [
          ...this.state.dataCampaign.Attachments,
          { ...attachment, Id: 0 },
        ];
        const newDataCampaign = {
          ...dataCampaign,
          Attachments: newAttachments,
        };
        this.setState({ loadingUpload: false, dataCampaign: newDataCampaign });
      } else {
        const { dataCampaign } = this.state;
        const newAttachments = [{ ...attachment, Id: 0 }];
        const newDataCampaign = {
          ...dataCampaign,
          Attachments: newAttachments,
        };
        this.setState({ loadingUpload: false, dataCampaign: newDataCampaign });
      }
    });
  };

  handleDeleteFile = id => {
    const { dataCampaign } = this.state;
    const newAttachments = dataCampaign.Attachments.filter(i => i.Id !== id);
    const newDataCampaign = { ...dataCampaign, Attachments: newAttachments };
    return this.setState({ dataCampaign: newDataCampaign });
    // return this.forceUpdate();
  };

  handleUpload = (event, attachmentType) => {
    const files = event.target.files;
    if (!files || !files.length) {
      return;
    } else {
      const file = files[0];
      const type = /[.]/.exec(file.name)
        ? /[^.]+$/.exec(file.name)[0]
        : undefined;
      const size = file.size / 1024 / 1024;
      if (size > 50) {
        notification.destroy();
        return notification.error({
          message: 'Error',
          description:
            'The file you have selected is too large. The maximum size is 50MB.',
        });
      } else if (FILE_EXTENSION.indexOf(type) === -1) {
        notification.destroy();
        return notification.error({
          message: 'Error',
          description: 'File type not permitted',
        });
      } else {
        this.handleUploadFile(files[0], attachmentType);
      }
    }
  };

  renderAttachment = attachmentType => {
    const { Attachments } = this.state.dataCampaign;
    if (Attachments && Attachments.length) {
      if (Attachments.length > 0) {
        const attachments = Attachments.filter(
          i => i.AttachmentType === attachmentType,
        );
        if (attachments.length === 0) {
          return null;
        }
        return attachments;
      }
      return null;
    }
    return null;
  };

  handleChangeContent = value => {
    const { dataCampaign } = this.state;
    this.setState({
      dataCampaign: { ...dataCampaign, CampaignContent: value },
    });
  };

  render() {
    const { record, id } = AddEditStore.modalParams;
    const { open } = AddEditStore;

    const { dataCampaign, loading } = this.state;
    const { channels, targetAudience, targetStatus } = AddEditStore;

    return (
      <Modal
        width={1200}
        onCancel={this.props.onCancel}
        visible={open}
        footer={
          <React.Fragment>
            <Button color="blue" onClick={this.handleSave}>
              Save
            </Button>
            <Button color="red" onClick={this.props.onCancel}>
              <Icon name="close" />
              Close
            </Button>
          </React.Fragment>
        }
        title={!id ? 'Add New Campaign' : record.CampaignName}
      >
        {loading ? (
          <Spin size="large" />
        ) : (
          <Form name="conversation" className="conversation-form">
            <Form.Item
              label="Campaign Name"
              required
              validateStatus={!dataCampaign.CampaignName ? 'error' : null}
              help={
                !dataCampaign.CampaignName ? 'This field is required' : null
              }
            >
              <Input
                value={dataCampaign.CampaignName}
                onChange={this.handleFieldChange('CampaignName')}
              />
            </Form.Item>
            <Form.Item label="Campaign Date">
              <DatePicker
                size="large"
                format="DD/MM/YYYY"
                value={dataCampaign.CampaignDate}
                onChange={this.handleFieldChange('CampaignDate')}
              />
            </Form.Item>
            <Form.Item label="Campaign Content">
              {/* <Input.TextArea
                rows={4}
                value={dataCampaign.CampaignContent}
                onChange={this.handleFieldChange('CampaignContent')}
              /> */}
              <CKEditor
                html={dataCampaign.CampaignContent}
                handleChangeContent={this.handleChangeContent}
              />
            </Form.Item>
            <Form.Item label="Attached Content">
              <div className="add-file-container-marketing-campaign">
                {this.renderAttachment(1) ? (
                  this.renderAttachment(1).map(i => (
                    <Message className="upload-box" key={i.Id}>
                      <div className="file-info">
                        <div className="file-info-inner">
                          <Icon name="file alternate" />
                          <div className="file-name">{i.Title}</div>
                        </div>
                        <div className="file-actions">
                          <Icon
                            name="download"
                            onClick={() => this.handleViewFile(i.FileName)}
                          />
                          <Icon
                            name="delete"
                            color="red"
                            onClick={() => this.handleDeleteFile(i.Id)}
                          />
                        </div>
                      </div>
                    </Message>
                  ))
                ) : (
                  <Message className="upload-box">
                    <div className="upload-file">
                      {this.state.uploadLoading && <Spin />}
                      <input
                        type="file"
                        onChange={event => this.handleUpload(event, 1)}
                      />
                      Click here to upload
                    </div>
                  </Message>
                )}
              </div>
            </Form.Item>
            <Form.Item label="Mail Merge Attachments">
              <div className="add-file-container-marketing-campaign">
                {this.renderAttachment(2) ? (
                  this.renderAttachment(2).map(i => (
                    <Message className="upload-box" key={i.Id}>
                      <div className="file-info">
                        <div className="file-info-inner">
                          <Icon name="file alternate" />
                          <div className="file-name">{i.Title}</div>
                        </div>
                        <div className="file-actions">
                          <Icon
                            name="download"
                            onClick={() => this.handleViewFile(i.FileName)}
                          />
                          <Icon
                            name="delete"
                            color="red"
                            onClick={() => this.handleDeleteFile(i.Id)}
                          />
                        </div>
                      </div>
                    </Message>
                  ))
                ) : (
                  <Message className="upload-box">
                    <div className="upload-file">
                      {this.state.uploadLoading && <Spin />}
                      <input
                        type="file"
                        onChange={event => this.handleUpload(event, 2)}
                      />
                      Click here to upload
                    </div>
                  </Message>
                )}
              </div>
            </Form.Item>
            <Form.Item label="Channel">
              <Select
                size="large"
                value={dataCampaign.Channel}
                onChange={this.handleFieldChange('Channel')}
                style={{ marginTop: '10px' }}
              >
                {channels.itemList.map(i => (
                  <Select.Option value={i.Id} key={i.Id}>
                    {i.Label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            {dataCampaign.Channel === 1665 && (
              <React.Fragment>
                <Form.Item
                  label="Subject"
                  validateStatus={
                    this.checkRequired('Subject') ? 'error' : null
                  }
                  help={
                    this.checkRequired('Subject')
                      ? 'This field is required'
                      : null
                  }
                  required
                >
                  <Input
                    value={dataCampaign.Subject}
                    onChange={this.handleFieldChange('Subject')}
                  />
                </Form.Item>
                <Form.Item
                  label="From"
                  validateStatus={this.checkRequired('From') ? 'error' : null}
                  help={
                    this.checkRequired('From') ? 'This field is required' : null
                  }
                  required
                >
                  <Input
                    value={dataCampaign.From}
                    onChange={this.handleFieldChange('From')}
                  />
                </Form.Item>
                <Form.Item
                  validateStatus={this.checkRequired('To') ? 'error' : null}
                  help={
                    this.checkRequired('To') ? 'This field is required' : null
                  }
                  label="To"
                  required
                >
                  <Input
                    value={dataCampaign.To}
                    onChange={this.handleFieldChange('To')}
                  />
                </Form.Item>
                <Form.Item label="Bcc">
                  <Input
                    value={dataCampaign.Bcc}
                    onChange={this.handleFieldChange('Bcc')}
                  />
                </Form.Item>
                <Form.Item label="Reply - to">
                  <Input
                    value={dataCampaign.ReplyTo}
                    onChange={this.handleFieldChange('ReplyTo')}
                  />
                </Form.Item>
              </React.Fragment>
            )}
            <Form.Item label="Target Audience">
              <Select
                size="large"
                value={dataCampaign.TargetAudience}
                onChange={this.handleFieldChange('TargetAudience')}
                style={{ marginTop: '10px' }}
              >
                {targetAudience.itemList.map(i => (
                  <Select.Option value={i.Id} key={i.Id}>
                    {i.Label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Target Status">
              <Select
                size="large"
                value={dataCampaign.TargetStatus}
                onChange={this.handleFieldChange('TargetStatus')}
                style={{ marginTop: '10px' }}
              >
                {targetStatus.itemList.map(i => (
                  <Select.Option value={i.Id} key={i.Id}>
                    {i.Label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Attached Contact List">
              <div className="add-file-container-marketing-campaign">
                {this.renderAttachment(3) ? (
                  this.renderAttachment(3).map(i => (
                    <Message className="upload-box" key={i.Id}>
                      <div className="file-info">
                        <div className="file-info-inner">
                          <Icon name="file alternate" />
                          <div className="file-name">{i.Title}</div>
                        </div>
                        <div className="file-actions">
                          <Icon
                            name="download"
                            onClick={() => this.handleViewFile(i.FileName)}
                          />
                          <Icon
                            name="delete"
                            color="red"
                            onClick={() => this.handleDeleteFile(i.Id)}
                          />
                        </div>
                      </div>
                    </Message>
                  ))
                ) : (
                  <Message className="upload-box">
                    <div className="upload-file">
                      {this.state.uploadLoading && <Spin />}
                      <input
                        type="file"
                        onChange={event => this.handleUpload(event, 3)}
                      />
                      Click here to upload
                    </div>
                  </Message>
                )}
              </div>
            </Form.Item>
            <Form.Item label="Location">
              <Select
                size="large"
                value={dataCampaign.Location}
                onChange={this.handleFieldChange('Location')}
                style={{ marginTop: '10px' }}
                mode="multiple"
                optionFilterProp="children"
              >
                {State.map(i => (
                  <Select.Option value={i.id} key={i.id}>
                    {i.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Volume (Number of Contacts Sent Out)">
              <Input
                value={dataCampaign.Volume}
                onChange={this.handleFieldChange('Volume')}
              />
            </Form.Item>
            <Form.Item label="Success Rate">
              <Input
                value={dataCampaign.SuccessRate}
                onChange={this.handleFieldChange('SuccessRate')}
              />
            </Form.Item>
            <Form.Item label="Response Rate">
              <Input
                value={dataCampaign.ResponsesRate}
                onChange={this.handleFieldChange('ResponsesRate')}
              />
            </Form.Item>
            <Form.Item label="Comment">
              <Input.TextArea
                rows={4}
                value={dataCampaign.Comment}
                onChange={this.handleFieldChange('Comment')}
              />
            </Form.Item>
          </Form>
        )}
      </Modal>
    );
  }
}

export default ConversationModalForm;
